module.exports = __webpack_public_path__ + "img/educloudtw.64101498.png";